import React, {Component} from 'react';
import 'assets/sass/common/InputText.scss';

export class InputText extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFilled: false,
            isFocus: false,

        };
        this.handleFocus = this.handleFocus.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }

    handleFocus() {
        this.setState({isFocus: true});
    }

    handleBlur(event) {
        const value = event.target.value;
        if (value.length !== 0) {
            this.setState({isFilled: true, isFocus: false});
        } else {
            this.setState({isFilled: false, isFocus: false});
        }
    }

    classNames() {
        return 'input-text ' +
            (this.state.isFilled ? ' filled' : '') +
            (this.props.error ? ' error' : '')
    }

    render() {
        return (
            <div className={this.classNames()}>
                <div className="input-text-focus">{this.props.helpText}</div>
                <input type="text" name={this.props.name} placeholder={this.props.placeholder}
                       onChange={this.props.handleChange} onBlur={this.handleBlur} onFocus={this.handleFocus}
                       maxLength={this.props.maxLength} defaultValue={this.props.defaultValue}
                       value={this.props.value}
                />
                <div className="input-label">{this.props.label}</div>
                <div className="error-message">{this.props.error}</div>
            </div>
        );
    }
}
